import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function sidebarIzquierdaReducer(state= initialState.sidebarIzquierda, action){
	
	switch(action.type){
		case types.ON_SIDEBAR_IZQUIERDA:	            
			return action.datos;
		//break;		
	
		default:
			return state;
	}
}